import useListQuery from './useListQuery';
import { dishCategoryService } from '../services';
import { sortCategories } from '../constants/dishCategoryPalette';

const useDishCategories = ({ autoFetch = true, includeDishCounts = true } = {}) => {
    const {
        data: categories,
        isPending,
        error,
        refetch,
        setData: setCategories,
    } = useListQuery({
        queryKey: ['dish-categories', includeDishCounts],
        enabled: autoFetch,
        queryFn: () => dishCategoryService.getCategories(includeDishCounts),
        select: (res) => ({ data: sortCategories(res.data || []) }),
    });

    return {
        categories,
        loading: isPending,
        error,
        fetchCategories: refetch,
        setCategories,
    };
};

export default useDishCategories;
